import Button from '@carvana/ds-button';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useConfiguration } from '~/context/common/StaticContext';
import { useIsDealershipPage } from '~/context/dealership/StaticContext';
import useIsSavedSearchApplied from '~/hooks/srp/useIsSavedSearchApplied';
import useLogInAndSaveSearch from '~/hooks/srp/useLogInAndSaveSearch';
import SimilarResultsSection from './SimilarResults/SimilarResultsSection';

export default function ZeroResultsSection() {
  const { shouldUseTitleCasing } = useConfiguration();
  const isDealership = useIsDealershipPage();
  const handleSaveSearch = useLogInAndSaveSearch();
  const trackEvent = useTrackEvent();
  const savedSearchIsApplied = useIsSavedSearchApplied();

  useEffect(() => {
    trackEvent('Zero Results Shown');

    datadogRum.addAction('Zero Results Shown');
  }, [trackEvent]);

  if (isDealership) {
    return (
      <div className="text-center text-text-strong t-heading-lg sm:t-heading-xl">
        No exact matches
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      {savedSearchIsApplied ? null : (
        <>
          <div
            className="flex flex-col items-center justify-center gap-2xl bg-white"
            data-testid="no-results-wrapper"
          >
            <div className="flex flex-col items-center justify-center gap-2xl">
              <div className="flex flex-col items-center gap-lg">
                <div className="text-text-strong t-heading-lg sm:t-heading-xl">
                  No exact matches
                </div>
                <div className="text-center text-text-default t-body-sm">
                  Save your search to get notified when more matches are
                  available.
                </div>
              </div>
            </div>
            <Button
              variant="primary"
              size="md"
              data-adobe-id={null}
              data-analytics-id="zero results notify me button"
              data-testid="save-search-zero-results"
              onClick={handleSaveSearch}
              className="w-full sm:w-fit"
            >
              {shouldUseTitleCasing ? 'Save Search' : 'Save search'}
            </Button>
          </div>
          <hr className="-mx-2xl my-4xl border-t border-border-subtle sm:-mx-3xl md:mx-0 md:my-7xl" />
        </>
      )}
      <SimilarResultsSection />
    </div>
  );
}
